<template>
  <!-- .etl ex-tab-list -->
  <div class="etl" v-if="list.length || tabTitle.length > 1">
    <div class="etl-title">
      <div class="title_dian">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="txt">Recommended Products</div>
    </div>
    <div class="etl-content">
      <van-sticky offset-top="46.5" v-if="tabTitle.length > 1">
        <Tabs v-model="active" :ellipsis="false" color="#1890ff" @change="changeHandle">
          <van-tab
            :title="item"
            :name="item"
            v-for="item in tabTitle"
            :key="item"
          ></van-tab>
        </Tabs>
      </van-sticky>
      <List
        v-if="list.length"
        :finished="true"
        :offset="100"
        class="my-box"
      >
        <div
          class="item"
          v-for="item in list"
          :key="item.id"
          @click="goToPro(item.id)"
        >
          <div class="item-t">
            <div class="item-t-img">
              <img v-if="item.video && JSON.parse(item.video).url" :src="JSON.parse(item.video).cover" >
              <img v-else :src="item.banner" v-load="'oPro'" />
              <div
                class="play_video"
                v-if="item.video && JSON.parse(item.video).url"
              >
                <i class="iconfont icon-zhibo"></i>
              </div>
            </div>
            <div class="item-t-info" v-if="item.categoryEn">
              <p>{{ item.categoryEn }}</p>
            </div>
            <div class="d_tag" v-if="item.view3DUrl">
              <i class="iconfont icon-d"></i>3D
            </div>
            <div class="img-v" v-if="item.panoramaUrl">
              <i class="iconfont icon-VR1" style="font-size=0.36rem"></i>
            </div>
            <!-- <div class="item-t-type" v-if="item.exhibitor.isLiving">
              <span class="my-brand dot">直播中</span>
            </div> -->
          </div>
          <div class="item-b">
            <div class="txt1">{{ item.name}}</div>
            <div class="txt2">
              {{ item.exhibitor.company.nameEn }}
            </div>
          </div>
        </div>
        <div v-if="loading" class="f-tac loading">
          <img src="@assets/img/new/icon-loading.png" />
          Loading...
        </div>
        <div class="f-tac loading" v-else-if="!finished" @click="onLoad">More</div>
        <div v-else class="f-tac loading">It's the end~</div>
      </List>
      <div class="u-empty" v-else>No data</div>
    </div>
  </div>
</template>

<script>
import { Tabs, List } from "vant";
import { mapActions, mapGetters, mapMutations } from "vuex";
import gql from "graphql-tag";
export default {
  name: "ex-tab-list",
  data() {
    return {
      loading: false,
      finished: false,
      active: "",
      tabTitle: [],
      categories: [],
      list: [],
      page: 1,
      size: 6,
      isTabClick: false,
    };
  },
  computed: {
    ...mapGetters({
      hostInfo: "getHostInfo",
      userInfo: "getUserInfo",
      exonId: "getExhibitionId",
    }),
    exhibitionId() {
      return this.$route.query.exhibitionId || this.exonId;
    },
    opt() {
      let opt = {
        exhibitionId: this.exhibitionId,
        page: this.page,
        size: this.size,
      };
      if (this.active != "All") {
        opt.categories = [this.active];
      }
      return opt;
    },
  },
  components: {
    List,
    Tabs,
  },
  created() {
    // this.init();
  },
  methods: {
    ...mapActions({
      LinkProduct: "linkTo/LinkProduct",
    }),
    goToPro(porId) {
      this.LinkProduct(porId);
    },
    onLoad() {
      if (this.finished || this.isTabClick) return;
      this.page += 1;
      this.$apollo.queries.getProduct.refetch({
        query: this.opt,
      });
    },
    getData() {
      this.loading = true;
      let query = gql`
        query getProduct($query: QueryProductInput!) {
          getProduct(query: $query) {
            hasNextPage
            pageIndex
            items {
              category
              categoryEn
              banner
              name
              nameEn
              id
              view3DUrl
              panoramaUrl
              video
              exhibitor {
                isLiving
                company {
                  name
                  nameEn
                }
              }
            }
          }
        }
      `;
      this.$apollo.addSmartQuery("getProduct", {
        query: query,
        variables: {
          query: this.opt,
        },
        fetchPolicy: "no-cache", //清理缓存
        result(res) {
          console.log("请 求回来了prolist", res);
          let data = JSON.parse(JSON.stringify(res.data.getProduct));
          // let data=res.data.giveExInfo;
          if (data) {
            data.items.forEach((e) => {
              if (e.category && e.category.indexOf("[") !== -1) {
                if (Array.isArray(JSON.parse(e.category))) {
                  if (JSON.parse(e.category)[0]) {
                    e.category = JSON.parse(e.category)[0].Value;
                  } else {
                    e.category = "";
                  }
                } else {
                  let cate = JSON.parse(e.category);
                  e.category = cate.Value;
                }
              }
              if (e.categoryEn && e.categoryEn.indexOf("[") !== -1) {
                if (Array.isArray(JSON.parse(e.categoryEn))) {
                  if (JSON.parse(e.categoryEn)[0]) {
                    e.categoryEn = JSON.parse(e.categoryEn)[0].Value;
                  } else {
                    e.categoryEn = "";
                  }
                } else {
                  let cate = JSON.parse(e.categoryEn);
                  e.categoryEn = cate.Value;
                }
              }
              if (e.banner && e.banner.indexOf("[") != -1) {
                let arr = JSON.parse(e.banner);
                e.banner = arr[0];
              }
            });
            if (data.pageIndex == 1) {
              this.list = data.items;
            } else {
              this.list = [...this.list, ...data.items];
            }
            // console.log(this.list,'list')
            this.loading = false;
            this.isTabClick = false;
            // console.log('推荐完成')
            if (!data.hasNextPage) {
              this.finished = true;
            }
          }
        },
        error(err) {},
      });
    },
    init() {
      let cateArr = [];
      console.log(this.userInfo, "用户信息");
      if (
        this.userInfo &&
        this.userInfo.inMember &&
        this.userInfo.inMember.category
      ) {
        let arr = this.userInfo.inMember.category.split(";");
        arr.forEach((e) => {
          let eArr = e.split(">");
          cateArr.push(eArr[0]);
        });
        // console.log(arr,'adrrrr')
      }
      this.tabTitle = [...new Set(cateArr)];
      // console.log(cateArr, this.tabTitle);
      if (this.tabTitle.length < 1) {
        this.tabTitle.unshift("All");
      }
      this.active = this.tabTitle[0];
      this.getData();
    },
    //获取数组  传一个数组json 遍历其下 id 于 name isLists 是否获取其list
    getList(arrJson, isLists = true) {
      let classArr = [];
      if (isLists) {
        if (arrJson) {
          arrJson.forEach((el) => {
            classArr.push({
              id: el.id,
              name:
                el.name.length > 4 ? el.name.substring(0, 3) + "..." : el.name,
              icon: el.icon,
              lists: this.getList(el.childrens, false),
            });
          });
        }
      } else {
        if (arrJson) {
          arrJson.forEach((el) => {
            classArr.push({
              id: el.id,
              name:
                el.name.length > 4 ? el.name.substring(0, 3) + "..." : el.name,
              icon: el.icon,
            });
          });
        }
      }
      return classArr;
    },
    changeHandle(e) {
      // console.log(e);
      this.page = 1;
      this.finished = false;
      this.isTabClick = true;
      this.list = [];
      this.$apollo.queries.getProduct.refetch({
        query: this.opt,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.etl {
  // background: #fff;
  &-title {
    padding: 0.25rem 0.3rem;
    display: flex;
    align-items: center;
    font-size: 0.3rem;
    color: #333;
    .title_dian {
      display: flex;
      justify-content: space-between;
      width: 0.06rem;
      height: 0.24rem;
      flex-direction: column;
      margin-right: 0.1rem;
      span {
        width: 0.06rem;
        height: 0.06rem;
        display: block;
        border-radius: 0.02rem;
        background-image: linear-gradient(90deg, #ff4b1b 0%, #fe781d 100%),
          linear-gradient(#108ee9, #108ee9);
        &:nth-child(1) {
          opacity: 0.5;
        }
        &:nth-child(2) {
          opacity: 0.75;
        }
      }
    }
    img {
      width: 13px;
    }
    .txt {
      // padding: 0 7px;
      font-size: 0.3rem;
      font-weight: bold;
    }
  }
  &-content {
    // min-height: calc(100vh - 0.93rem - 1rem);
    .my-box {
      padding: 0.3rem;
      padding: 15px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .item {
        margin-bottom: 10px;
        width: calc(50% - 6px);
        display: inline-block;
        height: 4.42rem;
        background-color: #fff;
        border-radius: 0.1rem;
        overflow: hidden;
        box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
        // border: solid 1px #dce4ec;
        &-t {
          width: 100%;
          height: 3.35rem;
          position: relative;
          // border-bottom: solid 1px #dce4ec;
          &-img {
            width: 100%;
            height: 100%;
            position: relative;
            z-index: 1;
            .play_video {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              background: rgba(0, 0, 0, 0.2);
              display: flex;
              align-items: center;
              justify-content: center;
              z-index: 2;
              i {
                font-size: 0.72rem;
                color: #fff;
              }
            }
            img {
              position: absolute;
              z-index: 1;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              margin: auto;
              // object-fit: cover;
              width: 100%;
              height: 100%;
            }
          }
          &-info {
            position: absolute;
            z-index: 2;
            bottom: 0;
            left: 0;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            // line-height: 20px;
            padding: 0 5px;
            background-color: rgba(#000, 0.5);
            color: #fff;
            width: 100%;
            p {
              font-size: 10px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
          }
          .d_tag {
            position: absolute;
            z-index: 1;
            width: 0.8rem;
            height: 0.35rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: #ff5c00;
            padding: 0 0.13rem 0 0.05rem;
            box-sizing: border-box;
            border-radius: 0 0 0 0.1rem;
            color: #fff;
            font-size: 0.2rem;
            right: 0;
            top: 0;
            .iconfont {
              font-size: 0.36rem;
            }
          }
          .img-v {
            position: absolute;
            z-index: 1;
            width: 0.58rem;
            height: 0.35rem;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #fff;

            box-sizing: border-box;
            border: 1px solid #0190fe;
            color: #0190fe;
            font-size: 0.2rem;
            left: 0;
            top: 0;
          }
          &-type {
            position: absolute;
            z-index: 1;
            top: 0.2rem;
            left: 0.2rem;
            .my-brand {
              width: 0.88rem;
              height: 0.3rem;
              display: flex;
              justify-content: center;
              align-items: center;
              background-image: linear-gradient(90deg, #ff416c 0%, #ff4b2b 100%),
                linear-gradient(#000, #000);
              background-blend-mode: normal, normal;
              border-radius: 0.05rem;
              color: #fff;
              font-size: 0.18rem;
              vertical-align: middle;
              margin-left: 0;
              &.dot {
                &::before {
                  content: "";
                  display: block;
                  width: 0.12rem;
                  height: 0.12rem;
                  border-radius: 50%;
                  background-color: #fff;
                  margin-right: 0.06rem;
                }
              }
            }
          }
        }
        &-b {
          padding: 0.12rem 0.2rem;
          .txt1 {
            font-size: 0.26rem;
            color: #333;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-bottom: 0.08rem;
            min-height: 0.34rem;
          }
          .txt2 {
            font-size: 0.22rem;
            color: #666;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
  &::v-deep {
    .van-tabs {
      .van-sticky {
        transform: none !important;
      }
      .van-tabs__wrap {
        .van-tabs__nav{
          overflow: hidden;
          overflow-x: auto;
        }
        .van-tab {
          // font-weight: normal;
          color: #646566;
          &.van-tab--active {
            color: #1890ff;
          }
        }
        &::after {
          border-width: 0 0 1px;
        }
      }
    }
    .van-tab {
      color: #666;
      font-size: 13px;
      // font-weight: 600;
      .van-tab__text {
        font-size: 0.28rem;
      }
    }
    .van-tab--active {
      color: #ff5c00;
    }
    .van-list__finished-text,
    .van-list__loading {
      width: 100%;
    }
  }
}
.f-tac {
  text-align: center;
  color: #969799;
  width: 100%;
  margin-top: 0.2rem;
}
.loading {
  
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;
    animation: 1s loader-01 linear infinite;
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>